import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import TotalCompetenceServices from "./TotalCompetence.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getTotalCompetence = (filters,type,setValue) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_COMPETENCIES_TOTAL,
      payload: true,
    });
    const resp = await TotalCompetenceServices.getTotalCompetence(filters);
    if(type===2){
      setValue(resp.data.data[0].total)
    }
    dispatch({
      type: actions.GET_COMPETENCIES_TOTAL,
      payload: {
        competenciesTotals: resp.data.data,
        competenciesTotalsLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.COMPETENCIES_TOTAL_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.COMPETENCIES_TOTAL_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COMPETENCIES_TOTAL,
      payload: false,
    });
  }
};

export const getTotalCompetenceById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_COMPETENCIES_TOTAL,
      payload: true,
    });
    const resp = await TotalCompetenceServices.getTotalCompetenceById(id);
    dispatch({
      type: actions.GET_COMPETENCIES_TOTAL,
      payload: {
        competenciesTotal: resp.data
      },
    });
    dispatch({
      type: actions.COMPETENCIES_TOTAL_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.COMPETENCIES_TOTAL_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COMPETENCIES_TOTAL,
      payload: false,
    });
  }
};

export const saveTotalCompetence = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_COMPETENCIES_TOTAL,
      payload: true,
    });
    const resp = await TotalCompetenceServices.saveTotalCompetence(data);
    const { competenciesTotals, competenciesTotalsLength } = getState().competenciesTotal;
    const _competenciesTotal = [...competenciesTotals, resp.data];
    dispatch({
      type: actions.GET_COMPETENCIES_TOTAL,
      payload: {
        competenciesTotals: _competenciesTotal,
        competenciesTotalsLength: competenciesTotalsLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_COMPETENCIES_TOTAL,
      payload: false,
    });
  }
};

export const editTotalCompetence = (data, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_COMPETENCIES_TOTAL,
      payload: true,
    });
    const resp = await TotalCompetenceServices.editTotalCompetence(id, data);
    const { competenciesTotals, competenciesTotalsLength } = getState().competenciesTotal;
    competenciesTotals[index] = resp.data;
    dispatch({
      type: actions.GET_COMPETENCIES_TOTAL,
      payload: {
        competenciesTotals: competenciesTotals,
        competenciesTotalsLength: competenciesTotalsLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COMPETENCIES_TOTAL,
      payload: false,
    });
  }
};

export const deleteTotalCompetence = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_COMPETENCIES_TOTAL,
      payload: true,
    });
    await TotalCompetenceServices.deleteTotalCompetence(id);
    const { competenciesTotals, competenciesTotalsLength } = getState().competenciesTotal;
    competenciesTotals.splice(index, 1);
    dispatch({
      type: actions.GET_COMPETENCIES_TOTAL,
      payload: {
        competenciesTotals: competenciesTotals,
        competenciesTotalsLength: competenciesTotalsLength - 1,
      },
    });
    dispatch({
      type: actions.COMPETENCIES_TOTAL_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.COMPETENCIES_TOTAL_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COMPETENCIES_TOTAL,
      payload: false,
    });
  }
};
